export const WelcomePublic = () => (
  <div>
    <h2>Mit Forløb (Public)</h2>
  </div>
);
